import styled from 'styled-components'
import {
  flexDirection,
  FlexDirectionProps,
  grid,
  GridProps,
  height,
  HeightProps,
} from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = (prop: string | number) => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const DesktopContent = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: auto 1fr;
  gap: ${themeGet('space.11')}px;
`

export const MobileItem = styled.div.withConfig({
  shouldForwardProp,
})<GridProps>`
  display: grid;
  align-items: center;
  width: 100%;
  gap: ${themeGet('space.5')}px;

  ${grid}
`

export const ItemHeader = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps & HeightProps>`
  display: flex;
  align-items: center;

  ${flexDirection}
  ${height}
`

export const ItemDash = styled.div`
  flex-shrink: 0;
  display: flex;
  width: 40px;
  height: 1px;
  background-color: ${themeGet('colors.border.slight')};
`
